import { AxiosError, Method } from "axios";

type Sentry = {
  data: {
    data: any;
    headers: any;
    method?: Method;
    status: number;
    url?: string;
  };
  fingerprint: string[];
};

export class AxiosErrorModel {
  constructor(private readonly error: AxiosError) {}

  public get data(): any | null {
    const { response } = this.error;

    if (!response) {
      return null;
    }

    return response.data;
  }

  public get status(): number {
    const { response } = this.error;

    if (!response) {
      return -1;
    }

    return response.status;
  }

  //

  public isBadRequest(): boolean {
    return this.status === 400;
  }

  public isForbidden(): boolean {
    return this.status === 403;
  }

  public isNotFoundError(): boolean {
    return this.status === 404;
  }

  public isUnauthorized(): boolean {
    return this.status === 401;
  }

  public toSentry(): Sentry {
    const { config } = this.error;

    return {
      data: {
        data: this.data,
        headers: config.headers,
        method: config.method,
        status: this.status,
        url: config.url,
      },
      fingerprint: [
        "axios",
        `${config.method}`,
        `${config.url}`,
        `${this.status || "any"}`,
      ],
    };
  }

  public wasEndpointNotFound(): boolean {
    if (!this.isNotFoundError()) {
      return false;
    }

    const data = this.data;

    if (!data || typeof data !== "string") {
      return false;
    }

    // we are validating against the default express return for not found routes, which is an html string
    if (
      data.includes("<!DOCTYPE html>") &&
      data.includes("<title>Error</title>") &&
      data.includes("<pre>Cannot ")
    ) {
      return true;
    }

    return false;
  }

  public wasInputInvalid(): boolean {
    if (!this.isBadRequest()) {
      return false;
    }

    const data = this.data;

    // this is the standard expected payload for joi validation errors
    if ("message" in data && data.message === "ERROR_INVALID_INPUT") {
      return true;
    }

    return false;
  }
}
